// extracted by mini-css-extract-plugin
module.exports = {"search":"Search-module--search--1PreE","search__input":"Search-module--search__input--2WAef","search__button":"Search-module--search__button--3uJbW"};